import { render } from "./PermisosView.vue?vue&type=template&id=ff003aa8"
import script from "./PermisosView.vue?vue&type=script&lang=js"
export * from "./PermisosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__